<template>
	<div
		ref="two_part_tree_block"
		class="element-tree-block-container flex-space-around--center overflow-visible flex-wrap"
		:class="{ 'choose-node': isChosen }"
	>
		<!-- here supposed to come FlowTreeActionBlock -->
		<slot name="first-part" />
		<div class="ui-element-block flex-space-around--center flex-col-12 button-content-bg">
			<div class="ui-element-container flex-col-12">
				<div class="ui-element max-width-100">
					<!-- here supposed to come whatever we want on our beautiful background -->
					<slot name="second-part" />
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { setFocusedElement } from '@/store/modules/flowTree/actions';
import { editNode } from '@/store/modules/selectedNode/getters';
import { mapActionsShorthand, mapGettersShorthand } from '@/store/utils/mappers';

export default {
	name: 'TwoPartsTreeBlock',
	props: { isChosen: { type: Boolean } },
	computed: {
		...mapGettersShorthand({ editNode }),
	},
	methods: {
		...mapActionsShorthand({ setFocusedElement }),
	},
	watch: {
		isChosen: {
			handler(newV) {
				newV && this.setFocusedElement(this.editNode.id);
			},
			immediate: true,
		},
	},
};
</script>

<style lang="scss" scoped>
.element-tree-block-container {
	position: relative;
	width: 290px;
	border: 1px solid #d6ddebeb;
	border-radius: 11px;
	overflow: hidden;
	background: white;
	box-shadow: none;

	// name of class in FlowTreeActionBlock
	::v-deep(.action-block) {
		border-top: none !important;
		border-right: none !important;
		border-left: none !important;
		border-bottom-left-radius: 0px !important;
		border-bottom-right-radius: 0px !important;
	}

	&.choose-node {
		border-color: #61b4f6;
		box-shadow: 0px 3px 6px rgba(110, 183, 255, 0.5) !important;
		background-color: var(--selected-tree-block-background);
		::v-deep(.action-block) {
			background-color: var(--selected-tree-block-background);
		}
		.button-content-bg {
			background: repeating-linear-gradient(
				-50deg,
				#e9eef4,
				#e9eef4 1px,
				var(--selected-tree-block-background) 1px,
				var(--selected-tree-block-background) 10px
			);
		}
	}
	.button-content-bg {
		background: repeating-linear-gradient(-50deg, #e9eef4, #e9eef4 1px, #ffffff 1px, #ffffff 10px);
		border-radius: 10px;
	}
	&:hover,
	&.choose-node {
		transition: all 0.2s;
	}
	&:hover:not(.choose-node) {
		.action-block {
			background-color: #f9fbfc;
		}
		.button-content-bg {
			background: repeating-linear-gradient(-50deg, #e9eef4, #e9eef4 1px, #f9fbfc 1px, #f9fbfc 10px);
		}
	}
	.ui-element-block {
		position: relative;
		min-height: var(--flow-tree-block-height);
		.ui-element-container {
			margin: 0 10px;
			max-width: calc(100% - 50px);

			.ui-element {
				display: inline-flex;
				padding: 7px 12px;
				transition: 0.2s;
			}
		}
	}
}
</style>
